import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { AppDispatchShape, RootStateShape } from './rootStateShape';

/** Typed Redux hooks every layer uses — see rootStateShape.ts for why these read the shared
 *  contract instead of `app/store`'s real (but FSD-unreachable-from-here) `RootState`. */
export const useAppDispatch: () => AppDispatchShape = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootStateShape> = useSelector;
